import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DownloadableResource = ({ title, fileType, fileSize, description, locked = true }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 flex items-center gap-4 hover:border-primary/30 transition-all duration-200">
      <div className="w-12 h-12 bg-muted/50 rounded-lg flex items-center justify-center shrink-0">
        <Icon name="FileText" size={24} color="var(--color-primary)" strokeWidth={2} />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm font-semibold text-foreground mb-1 truncate">{title}</h4>
        <p className="text-xs text-muted-foreground mb-2 line-clamp-1">{description}</p>
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span className="font-medium text-primary">{fileType}</span>
          <span>•</span>
          <span>{fileSize}</span>
        </div>
      </div>
      <Button
        variant="outline"
        size="sm"
        disabled={locked}
        iconName={locked ? "Lock" : "Download"}
        iconPosition="left"
      >
        {locked ? "Locked" : "Download"}
      </Button>
    </div>
  );
};

export default DownloadableResource;